import type { CityConfig } from "../city-template/types";

export const fortThomasConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fort Thomas",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "fort-thomas",
  route: "/fort-thomas",
  title: "Emergency Passport Fort Thomas, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Fort Thomas, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Campbell County, Northern Kentucky, and Cincinnati metro travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Fort Thomas, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fort Thomas and Campbell County travelers get their expedited passports as quickly as 24 hours. Serving the historic military district, Ohio River bluff neighborhoods, and the entire Cincinnati metro area. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fort%20Thomas%20Kentucky%20historic%20military%20district%20with%20charming%20tree-lined%20streets%20and%20elegant%20historic%20homes%2C%20Ohio%20River%20bluff%20area%20with%20panoramic%20views%20of%20Cincinnati%20skyline%2C%20well-maintained%20suburban%20community%20with%20brick%20homes%20and%20manicured%20lawns%2C%20clean%20residential%20photography%20with%20warm%20daylight%2C%20no%20visible%20text%20or%20people%2C%20Northern%20Kentucky%20historic%20neighborhood%2C%20wide%20panoramic%20view&width=1800&height=700&seq=fort-thomas-hero-001&orientation=landscape",
  heroImageAlt: "Fort Thomas Kentucky historic district with tree-lined streets and Ohio River bluff views of Cincinnati",
  geoPosition: "39.0751;-84.4483",
  geoPlacename: "Fort Thomas, Kentucky",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 300 miles from Fort Thomas via I-74 and I-65",
  },
  nearbyCitiesZips: [
    { name: "Fort Thomas", zips: "41075, 41076" },
    { name: "Newport", zips: "41071, 41072, 41075, 41076, 41099" },
    { name: "Covington", zips: "41011, 41012, 41014, 41015, 41016, 41017, 41018, 41019" },
    { name: "Bellevue", zips: "41073, 41074" },
    { name: "Dayton", zips: "41074, 41073, 41075, 41076, 41099" },
    { name: "Ludlow", zips: "41016, 41099" },
    { name: "Florence", zips: "41022, 41042, 41043, 41044" },
    { name: "Erlanger", zips: "41018, 41017, 41051" },
    { name: "Independence", zips: "41051, 41052, 41053, 41054, 41055, 41056, 41057, 41058, 41059, 41060, 41061, 41062, 41063, 41064, 41065, 41066, 41067, 41068, 41069, 41070, 41071, 41072, 41073, 41074, 41075, 41076, 41077, 41078, 41079, 41080, 41081, 41082, 41083, 41084, 41085, 41086, 41087, 41088, 41089, 41090, 41091, 41092, 41093, 41094, 41095, 41096, 41097, 41098, 41099" },
    { name: "Park Hills", zips: "41011, 41017, 41075" },
    { name: "Fort Mitchell", zips: "41011, 41017, 41051" },
    { name: "Edgewood", zips: "41017, 41018, 41051" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Campbell County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Newport", route: "/newport" },
    { name: "Fast passport renewal in Covington", route: "/covington" },
    { name: "Emergency passport help in Louisville", route: "/louisville" },
    { name: "Urgent passport services in Lexington", route: "/lexington" },
    { name: "Same-day passport help in Florence", route: "/florence" },
    { name: "Passport courier services near Erlanger", route: "/erlanger" },
  ],
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeNote: "Fast Passport Center serves Fort Thomas remotely via secure courier. We do not have a walk-in office in Fort Thomas — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Campbell County travelers.",
  fpcOfficeDistance: "Serving all of Campbell County and the Northern Kentucky Cincinnati metro area",
  serviceAreaIntro: "From the historic Tower Park area to the Ohio River bluff neighborhoods, from the Fort Thomas Avenue corridor to the quiet residential streets near the Highlands — Fast Passport Center serves the entire Fort Thomas community. We regularly help travelers from Newport, Bellevue, and Dayton get their passports fast.",
  nearbyCitiesIntro: "We serve all Fort Thomas neighborhoods and nearby Campbell County cities including Newport, Bellevue, Dayton, and Ludlow, as well as Kenton County neighbors like Covington, Florence, Erlanger, and Independence. If you are in Campbell County, Northern Kentucky, or the Cincinnati metro area, we have you covered.",
  howItWorksIntro: "Most Fort Thomas travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Fort Thomas travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fort Thomas and Campbell County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fort Thomas? Here are the most common ones we hear from Campbell County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Campbell County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Thomas B.",
      location: "Fort Thomas, KY",
      rating: 5,
      text: "Military reunion trip to Germany with old Army buddies in 4 days. My passport was expired. Fast Passport Center got it renewed in 36 hours. They even accommodated my specific shipping needs. Outstanding service for veterans.",
      service: "Passport Renewal",
    },
    {
      name: "Karen S.",
      location: "Newport, KY",
      rating: 5,
      text: "Emergency family trip to Ireland for my mother's health. Fast Passport Center understood the urgency and processed my passport in 24 hours. I made it to Dublin from CVG to see her. Words cannot express my gratitude.",
      service: "Emergency Passport",
    },
    {
      name: "Paul G.",
      location: "Bellevue, KY",
      rating: 5,
      text: "Coaching a youth soccer tournament in Canada and my passport was lost. They got me a replacement in 2 days. The team made the tournament in Toronto. Fast Passport Center is a lifesaver for Campbell County coaches.",
      service: "Lost Passport",
    },
    {
      name: "Nancy H.",
      location: "Dayton, KY",
      rating: 5,
      text: "My husband surprised me with a Mediterranean cruise for our 25th anniversary. My passport was expired. Fast Passport Center renewed it in 4 days. We sailed from Barcelona and it was the trip of a lifetime.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "fort-thomas-1",
      name: "Fort Thomas Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "24 S Fort Thomas Ave",
      city: "Fort Thomas",
      state: "KY",
      zip: "41075",
      phone: "(859) 441-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from Fort Thomas center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary facility for Campbell County residents. Convenient for Fort Thomas area. Appointments recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fort-thomas-2",
      name: "Newport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W 10th St",
      city: "Newport",
      state: "KY",
      zip: "41071",
      phone: "(859) 291-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.5 miles from Fort Thomas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Campbell County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fort-thomas-3",
      name: "Campbell County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "330 York St",
      city: "Newport",
      state: "KY",
      zip: "41071",
      phone: "(859) 292-3845",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "3.0 miles from Fort Thomas",
      website: "https://www.campbellcountyky.gov/",
      websiteLabel: "Campbell County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "fort-thomas-4",
      name: "Covington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 W 5th St",
      city: "Covington",
      state: "KY",
      zip: "41011",
      phone: "(859) 261-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "4.0 miles from Fort Thomas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Kenton County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fort-thomas-5",
      name: "Bellevue Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "313 Fairfield Ave",
      city: "Bellevue",
      state: "KY",
      zip: "41073",
      phone: "(859) 261-3511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.5 miles from Fort Thomas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Bellevue residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fort-thomas-6",
      name: "Dayton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "625 6th Ave",
      city: "Dayton",
      state: "KY",
      zip: "41074",
      phone: "(859) 261-4511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "2.0 miles from Fort Thomas",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Dayton and nearby Campbell County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cincinnati metro photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Campbell County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fort Thomas applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Campbell County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Northern Kentucky travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fort Thomas." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fort Thomas address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fort Thomas before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fort Thomas for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Fort Thomas?", a: "Fast Passport Center offers fast passport renewal in Fort Thomas in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Fort Thomas in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Fort Thomas?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 5 hour drive from Fort Thomas — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Campbell County residents." },
    { q: "Can I expedite a child passport in Fort Thomas?", a: "Yes. Fast Passport Center expedites child passports in Fort Thomas for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Campbell County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fort Thomas with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Fort Thomas?", a: "With Fast Passport Center's emergency courier service, Fort Thomas travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Fort Thomas?", a: "Popular options include the Fort Thomas Post Office (41075), Newport Post Office (41071), Campbell County Clerk (41071), Covington Post Office (41011), Bellevue Post Office (41073), and Dayton Post Office (41074). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Fort Thomas?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 5 hour drive to Chicago." },
    { q: "What if I live in the Cincinnati metro area?", a: "We serve the entire Northern Kentucky Cincinnati metro including Newport, Covington, Florence, Erlanger, Independence, Bellevue, Dayton, and Ludlow. Our overnight shipping labels work from any UPS location, so your location on either side of the river doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Fort Thomas?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Fort Thomas?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Fort Thomas, Newport, and Florence offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Fort Thomas?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Fort Thomas?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Campbell County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fort Thomas", address: "90 N Fort Thomas Ave, Fort Thomas, KY 41075", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Fort Thomas", address: "115 S Fort Thomas Ave, Fort Thomas, KY 41075", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Newport", address: "1301 Monmouth St, Newport, KY 41071", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Florence", address: "7625 Doering Dr, Florence, KY 41042", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "CVS Pharmacy — Covington", address: "25 W 5th St, Covington, KY 41011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Bellevue", address: "319 Fairfield Ave, Bellevue, KY 41073", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Rite Aid — Newport", address: "415 E 6th St, Newport, KY 41071", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations" },
    { name: "FedEx Office — Florence", address: "4990 Houston Rd, Florence, KY 41042", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Campbell County",
      address: "330 York St, Newport, KY 41071",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Kenton County",
      address: "303 Court St, Covington, KY 41011",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Boone County",
      address: "2950 Washington St, Burlington, KY 41005",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Boone County residents.",
      featured: false,
    },
    {
      name: "Ohio BMV — Cincinnati",
      address: "5721 Dragon Way, Cincinnati, OH 45227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Ohio residents across the river. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International",
      distance: "10 miles from Fort Thomas",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "The primary airport for Campbell County and the Northern Kentucky Cincinnati metro area. Domestic and international flights to major hubs worldwide.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "100 miles from Fort Thomas",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: false,
    },
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "85 miles from Fort Thomas",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "Alternative regional airport for central Kentucky flights.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Kentucky Office of Vital Statistics in Frankfort — order certified copies online, by mail, or in person for passport applications and name changes.", url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Campbell County Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.campbellcountyky.gov/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Campbell Circuit Court Clerk — certified divorce decrees supporting passport name change or correction.", url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Campbell.aspx" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Kentucky, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};